export default "__VITE_ASSET__5338ff17__$_?component__"